import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { VehicleImportModel } from 'src/app/models/imports/vehicle-import-model';
import { environment } from 'src/environments/environment';
import { VehicleModel } from './../../models/archive/vehicle-model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private _httpClient: HttpClient) { }

  createVehicle(VehicleContract: VehicleModel): Observable<VehicleModel> {
    return this._httpClient.post<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.CreateVehicle}`,
      VehicleContract);
  }

  deleteVehicle(vehicleId: number): Observable<VehicleModel> {
    return this._httpClient.delete<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.DeleteVehicle}/${vehicleId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllVehiclesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetAllVehiclesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllConceptsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetAllConceptsForSelectAsync}`);
  }

  getAllVehiclesForSelectAsync(branchId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetAllVehiclesForSelectAsync}/${branchId}`);
  }

  getAllStoresForSelectAsync(branchId: number): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetAllStoresForSelectAsync}`,
      { params: params }
    );
  }

  getCityDepartment(cityId: number): Observable<string> {
    const params = new HttpParams().set('cityId', cityId);
    return this._httpClient.get<string>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetCityDepartmentAsync}`,
      { params: params }
    );
  }

  getCitiesForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetCitiesForSelectionAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForCitiesSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetColumnsForCitiesSelectionAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstVehicleByKeysAsync(branchId: number): Observable<VehicleModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetFirstVehicleByKeysAsync}`,
      { params: params }
    );
  }

  getLastVehicleByKeysAsync(branchId: number): Observable<VehicleModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetLastVehicleByKeysAsync}`,
      { params: params }
    );
  }

  getNextVehicleByKeysAsync(branchId: number, code: number): Observable<VehicleModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetNextVehicleByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusVehicleByKeysAsync(branchId: number, code: number): Observable<VehicleModel> {
    const params = new HttpParams().set('branchId', branchId).set('code', code);
    return this._httpClient.get<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetPreviusVehicleByKeysAsync}`,
      { params: params }
    );
  }

  getVehicleByBranchId(branchId: number): Observable<Array<VehicleModel>> {
    return this._httpClient.get<Array<VehicleModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetVehicleByBranchId}/${branchId}`);
  }

  getVehicleByCodeAsync(branchId: number, code: number): Observable<VehicleModel> {
    return this._httpClient.get<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetVehicleByCodeAsync}/${branchId}/${code}`)
  }

  getVehicleById(vehicleId: number): Observable<VehicleModel> {
    return this._httpClient.get<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.GetVehicleById}/${vehicleId}`);
  }

  importVehicles(vehicleImports: Array<VehicleImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.ImportVehicles}`, vehicleImports);
  }

  setActiveVehicle(vehicleId: number): Observable<VehicleModel> {
    return this._httpClient.put<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.SetActiveVehicle}/${vehicleId}`,
      null);
  }

  updateVehicle(VehicleContract: VehicleModel): Observable<VehicleModel> {
    return this._httpClient.put<VehicleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.vehicle.UpdateVehicle}`,
      VehicleContract);
  }
}
